
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 6v17H1V6h17zm-2 2H3v13h13V8zm-5.625 3v2.625H13v1.75h-2.625V18h-1.75v-2.625H6v-1.75h2.625V11h1.75zM22.999 1v16H19v-2h2V3H9v2H7V1h16z"}})])
          )
        }
      }
    